import Vue from 'vue';
import { callMaui, openUrl } from './modules/mauiBridge.js'
Vue.prototype.$callMaui = callMaui;
Vue.prototype.$openUrl = openUrl;
import App from './App.vue';
import Router from './router';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Store from './store/store'
import UpdaterHub from './plugins/updater-hub'
import SyncHub from './plugins/sync-hub'
import VueCookie from 'vue-cookie'

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(UpdaterHub);
Vue.use(SyncHub);
Vue.use(VueCookie);

export const bus = new Vue();

new Vue({
    vuetify: new Vuetify({
        theme: {
            themes: {
                light: {
                    background: '#F4F6F9',
                },
            },
        },
    }),
    router: Router,
    store: Store,
    render: h => h(App),
}).$mount('#app')